import { useState } from "react";
import { BarChart3, BriefcaseBusiness, Building2, CalendarDays, FileSpreadsheet, FileText, KeyRound, LayoutDashboard, LogOut, Menu, Tags, Trash2, Users, UsersRound, WalletCards } from "lucide-react";
import { useAuth } from "../../auth";
import { ROLE_LABELS } from "../../api";
import ChangePasswordModal from "../ChangePasswordModal";

const items = [
  ["Genel Bakış", LayoutDashboard, "dashboard"],
  ["Projeler", BriefcaseBusiness, "projects"],
  ["İşverenler", Building2, "employers"],
  ["Alt Yükleniciler", Users, "subcontractors"],
  ["Ödemeler", WalletCards, "payments"],
  ["Teklifler", FileText, "quotes"],
  ["Finans & Raporlar", BarChart3, "finance"],
  ["İzin & Takvim", CalendarDays, "leave", "leave"],
  ["Kategoriler", Tags, "categories", ["admin", "project_manager"]],
  ["Çöp Kutusu", Trash2, "trash", ["admin", "project_manager"]],
  ["Excel İçe Aktar", FileSpreadsheet, "import", "admin"],
  ["Kullanıcılar", UsersRound, "users", "super"],
];

export default function Sidebar({ active, setActive, collapsed, setCollapsed }) {
  const { user, logout } = useAuth();
  const [pwOpen, setPwOpen] = useState(false);
  const visible = items.filter(([, , , role]) => {
    if (user?.role === "calisan") return role === "leave";
    if (!role) return true;
    if (role === "super") return !!user?.is_super_admin;
    if (role === "leave") return user?.role === "admin" || !!user?.is_super_admin;
    return Array.isArray(role) ? role.includes(user?.role) : user?.role === role;
  });
  return (
    <aside className={`sidebar ${collapsed ? "collapsed" : ""}`} data-testid="sidebar">
      <div className="brand">
        <img className="brand-mark" src="/brand/reen-mark-light.png" alt="REEN Energy" />
        {!collapsed && <div><b>REEN ENERGY</b><small>PROJE & FİNANS KONTROL</small></div>}
      </div>
      <button className="collapse-btn" onClick={() => setCollapsed(!collapsed)} data-testid="sidebar-toggle-button">
        <Menu size={17} />
      </button>
      <nav>
        {visible.map(([name, Icon, key]) => (
          <button key={key} className={active === key ? "nav-active" : ""} onClick={() => setActive(key)} data-testid={`nav-${key}`}>
            <Icon size={18} />
            {!collapsed && <span>{name}</span>}
            {active === key && <i />}
          </button>
        ))}
      </nav>
      <div className="sidebar-bottom">
        {!collapsed && (
          <div className="workspace" data-testid="sidebar-user">
            <span className="online-dot" />
            <div><b>{user?.name}</b><small>{user?.is_super_admin ? "Ana Yönetici" : (ROLE_LABELS[user?.role] || user?.role)}</small></div>
          </div>
        )}
        <button className="settings-btn" onClick={() => setPwOpen(true)} data-testid="change-password-button">
          <KeyRound size={17} />{!collapsed && "Şifre Değiştir"}
        </button>
        <button className="settings-btn" onClick={logout} data-testid="logout-button">
          <LogOut size={17} />{!collapsed && "Çıkış yap"}
        </button>
      </div>
      {pwOpen && <ChangePasswordModal close={() => setPwOpen(false)} />}
    </aside>
  );
}
